export default "__VITE_ASSET__Csb21Pl6__"